import UnitInputPage from "@components/UnitInputPage"

export default function Height() {
  return (
    <UnitInputPage
      translationKey="height"
      metricUnit={{
        value: "cm",
        label: "cm",
        placeholder: "165",
        conversionFactor: 1,
      }}
      imperialUnit={{
        value: "in",
        label: "in",
        placeholder: "65",
        conversionFactor: 2.54,
      }}
    />
  )
}
